import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { AccountHeaderTitle } from "../../components/AccountHeader";
import { InlineType } from "../../components/InlineType";
import { SuccessNotification } from "../../features/Search/components/SuccessNotification";
import { PropertiesContainer } from "../../features/Properties/PropertiesContainer";
import { ActivityContainer } from "../../features/Activities/ActivityContainer";
import { FinancialSummary } from "../../features/FinancialSummary";
import { AccountContacts } from "../../features/AccountContacts";
import { AccountWarnings } from "../../features/AccountWarnings/AccountWarnings";
import { useAccount } from "../../api/hooks";
import { AccountStatus } from "../../components/AccountStatus";
import { CaseIconLarge } from "../../icons";
import { useFallbackUrl } from "../../components/AppHistory";
import { PageComponent } from "../routes";

export const DashboardView: PageComponent = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);

  const { accountNumber } = useParams();
  const { data: account } = useAccount(accountNumber);

  const isCancelled = account?.status === "Cancelled";

  return (
    <>
      <Helmet>
        <title>{`${accountNumber} - Account Dashboard`}</title>
      </Helmet>

      {/* Account Header Title */}
      <AccountHeaderTitle>
        <Box mr={1} clone>
          <CaseIconLarge width={36} height={36} />
        </Box>
        <InlineType textDecoration={isCancelled ? "line-through" : undefined}>
          <Typography
            variant="h4"
            color={isCancelled ? "textSecondary" : undefined}
          >
            {accountNumber}
          </Typography>
        </InlineType>
      </AccountHeaderTitle>

      {/* Content of the page */}
      <Box display="flex" p={3}>
        <Box flexGrow={1}>
          <SuccessNotification />
          <AccountWarnings mb={4} />
          {!isCancelled && <FinancialSummary />}
          {account && <AccountStatus account={account} />}
          {!isCancelled && (
            <PropertiesContainer accountNumber={accountNumber!} my={4.5} />
          )}
          <Box my={4.5}>
            <AccountContacts />
          </Box>
        </Box>
        <Box flexShrink={1} ml={3}>
          <ActivityContainer accountNumber={accountNumber!} />
        </Box>
      </Box>
    </>
  );
};
